import { formatNumberBasedOnUser } from "utils/namesManipulation";
import { getCSSVar } from "utils/styling";

import type { EnergyAnalysisCategoryTotal } from "../model/types";

export const buildDoughnutOption = (categoryTotals: EnergyAnalysisCategoryTotal[], variant: "doughnut" | "pie") => ({
  dataZoom: [],
  legend: { show: false },
  series: [
    {
      center: ["50%", "50%"],
      data: categoryTotals.map((item) => ({
        itemStyle: { color: item.color },
        name: item.label,
        value: item.value,
      })),
      emphasis: { scale: false },
      itemStyle: {
        borderColor: getCSSVar("--color-purpose-graph-pie-slice-border") || getCSSVar("--color-surface-bright"),
        borderRadius: 4,
        borderWidth: 2,
      },
      label: { show: false },
      labelLine: { show: false },
      radius: variant === "pie" ? "70%" : ["46%", "70%"],
      type: "pie",
    },
  ],
  tooltip: {
    trigger: "item",
    valueFormatter: (value: number) => formatNumberBasedOnUser(value, 2),
  },
});
